<script lang="ts">
import { Participant } from '@/entities/Participant';
import { Room } from '@/entities/Room';
import ParticipantServiceInterface from '@/services/interfaces/ParticipantServiceInterface';
import { defineComponent, inject } from 'vue';

export default defineComponent({
  name: 'FooterComponent',
  props: {
    participant: {
      type: Object,
      default: {} as Participant,
    },
    room: {
      type: Object,
      default: {} as Room,
    },
    clearData: {
      type: Function,
      default: () => null,
    },
  },
  computed: {
    message(): string {
      return ` ${this.participant?.name} ${
        this.participant.exists ? 'já está ' : 'foi adicionado'
      } na <br /> ${this.room.name}`;
    },
  },
  setup(props) {
    const participantService =
      inject<ParticipantServiceInterface>('participantService');
    const removeParticipant = () =>
      participantService
        ?.removeParticipant({
          reference_number: props.participant.reference_number,
          room_id: props.room.id,
        })
        .then(() => props.clearData());

    return { removeParticipant };
  },
});
</script>

<template>
  <footer
    class="flex items-center w-full flex-col text-white absolute bottom-0 footer"
  >
    <div
      class="w-24 h-24 bg-white -mt-12 rounded-full flex justify-center items-center footer-icon z-20"
    >
      <img
        src="@/assets/alert.svg"
        class="w-16 h-16"
        v-if="participant.exists"
      />
      <img src="@/assets/check.svg" class="w-16" v-else />
    </div>
    <div
      class="h-full w-full flex flex-col justify-between p-10 pt-20 box-info"
    >
      <p class="text-center font-normal" v-html="message"></p>
      <div class="flex gap-5 justify-center">
        <button
          class="btn-primary bg-white text-blue-800 font-bold text-lg p-3 rounded-2xl custom-button w-full max-w-[50%]"
          :onclick="clearData"
        >
          Fechar
        </button>
        <button
          class="btn-primary bg-red-400 text-white font-bold text-lg p-3 rounded-2xl w-full custom-button"
          v-if="participant.exists"
          :onclick="removeParticipant"
        >
          Remover
        </button>
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
.footer {
  height: 35%;
  background: rgba(1, 90, 187, 0.78);

  @media (max-height: 667px) {
    height: 30%;
  }
}

.footer-icon {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  @apply border-blue-200 border-2;
}

.box-info {
  @media (max-height: 667px) {
    padding-top: 3rem;
    padding-bottom: 1rem;
  }
}

.custom-button {
  @media (max-height: 667px) {
    padding: 0.5rem;
  }
}
</style>
